import { Monitor, Smartphone } from "lucide-react";

/** PageSpeed strategies and Lighthouse categories, shared by the metrics panel and the report. */
export const STRATEGIES = [
  { value: "mobile", label: "Móvil", icon: Smartphone },
  { value: "desktop", label: "Ordenador", icon: Monitor },
];

export const SCORE_CARDS = [
  { key: "performance", label: "Rendimiento" },
  { key: "accessibility", label: "Accesibilidad" },
  { key: "best_practices", label: "Prácticas recomendadas" },
  { key: "seo", label: "SEO" },
];
